import { Routes, Route } from 'react-router-dom'

import Dealers from 'pages/Dealers'
import MigrateDealer from 'pages/MigrateDealer'
import NotFound from 'pages/NotFound'

const DealersRouter = () => {
  return (
    <Routes>
      <Route path=":id/migrate" element={<MigrateDealer />} />
      <Route path="/" index element={<Dealers />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default DealersRouter
